import React from 'react'
import moment from 'moment'

export default class HistoryChoser extends React.Component {


  render() {

    let historyRecords = this.props.records

    if(historyRecords && historyRecords.length) {

      let mapped = historyRecords.map((record,id)=>{

        return <a className="list-group-item small" href="#" key={id} onClick={(e)=>{
          e.preventDefault();
          this.props.handleHistorySelect(record.obj)
        }}>
              <div>{record.user.username}</div>
              <div className=" text-muted">
              <i>{moment(record.created).format('DD-MMM-YYYY HH:mm')}</i>
              </div>
        </a>
      })

      return <div className="panel panel-warning">
        <div className="panel-heading">
        <h4>History</h4>
        </div>

        <div className="list-group">
        {mapped}
        </div>
      </div>

    }
    else {
      return null
    }

  }
}



// WEBPACK FOOTER //
// ./src/components/invoice/historyChoser.js